import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import { ModeltypeBasicDto, TechnicalDataDto } from 'src/services/Client';

export interface ITechnicalDataState {
  derivates?: ModeltypeBasicDto[];
  technicalData?: TechnicalDataDto[];
  /** Derivates for the technical data context */
  technicalDataDerivates: ModeltypeBasicDto[];
}

const INITIAL_STATE: ITechnicalDataState = {
  derivates: undefined,
  technicalData: undefined,
  technicalDataDerivates: [],
};

export const technicalDataReducer = (
  state: ITechnicalDataState = INITIAL_STATE,
  action: AnyAction
): ITechnicalDataState => {
  switch (action.type) {
    case ActionTypes.RECEIVE_DERIVATES:
      return {
        ...state,
        derivates: action.data,
      };
    case ActionTypes.UNLOAD_DERIVATES:
      return {
        ...state,
        derivates: undefined,
      };
    case ActionTypes.RECEIVE_TECHNICAL_DATA:
      return {
        ...state,
        technicalData: action.data,
      };
    case ActionTypes.UNLOAD_TECHNICAL_DATA:
      return {
        ...state,
        technicalData: undefined,
      };
    case ActionTypes.UNLOAD_TECHNICAL_DATA_DERIVATES:
      return {
        ...state,
        technicalDataDerivates: [],
      };
    case ActionTypes.RECEIVE_TECHNICAL_DATA_DERIVATES:
      return {
        ...state,
        technicalDataDerivates: action.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/technicalDataReducer.ts